import React, { useEffect, useState } from 'react';
import { buildUrl } from '../services/api';

const SharePage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [meta, setMeta] = useState(null);
  const [passcode, setPasscode] = useState('');
  const [downloadUrl, setDownloadUrl] = useState('');

  const token = typeof window !== 'undefined' ? (new URLSearchParams(window.location.search).get('token') || '') : '';

  useEffect(() => {
    const load = async () => {
      if (!token) { setError('Missing token'); setLoading(false); return; }
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(buildUrl(`/shares/${encodeURIComponent(token)}`));
        if (!res.ok) {
          const err = await res.json().catch(()=>({}));
          throw new Error(err.detail || 'Invalid or expired link');
        }
        const data = await res.json();
        setMeta(data.meta || {});
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [token]);

  const requestDownload = async () => {
    if (!token) return;
    setError(null);
    try {
      const res = await fetch(buildUrl(`/shares/${encodeURIComponent(token)}/download`), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ passcode: passcode || null })
      });
      if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        throw new Error(err.detail || 'Unable to generate download link');
      }
      const data = await res.json();
      setDownloadUrl(data.presigned_url);
      // Auto-open in new tab
      try {
        const a = document.createElement('a');
        a.href = data.presigned_url;
        a.rel = 'noopener noreferrer';
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (_) {}
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow rounded-lg p-6">
        <h1 className="text-xl font-semibold text-gray-900 mb-2">File Share</h1>
        {loading ? (
          <p className="text-gray-600">Loading…</p>
        ) : error ? (
          <div className="text-red-600 text-sm">{error}</div>
        ) : (
          <>
            <div className="text-gray-700 text-sm mb-3">
              <div><span className="font-medium">File:</span> {meta?.filename || 'Unknown'}</div>
              <div><span className="font-medium">Downloads left:</span> {meta?.remaining_downloads ?? 0}</div>
            </div>
            {meta?.requires_passcode && (
              <div className="mb-3">
                <label className="block text-sm text-gray-700 mb-1">Passcode</label>
                <input value={passcode} onChange={(e)=>setPasscode(e.target.value)} className="w-full border rounded px-3 py-2" placeholder="Enter passcode" />
              </div>
            )}
            <button onClick={requestDownload} className="w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Download</button>
            {downloadUrl && (
              <div className="mt-3 text-xs text-gray-500 break-all">Direct link: {downloadUrl}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SharePage;



